<template><!-- svgo-optimised -->
<svg class="icon icon__caret icon__caret--up" viewBox="0 0 10 6.45" xmlns="http://www.w3.org/2000/svg"><path d="M5 0 0 6.45h10L5 0z"/></svg></template>